import { render, staticRenderFns } from "./goodsCreate.vue?vue&type=template&id=0a50ecec&scoped=true"
import script from "./goodsCreate.vue?vue&type=script&lang=js"
export * from "./goodsCreate.vue?vue&type=script&lang=js"
import style0 from "./goodsCreate.vue?vue&type=style&index=0&id=0a50ecec&prod&lang=less&scoped=true"
import style1 from "./goodsCreate.vue?vue&type=style&index=1&id=0a50ecec&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a50ecec",
  null
  
)

export default component.exports